"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IUILanguageFactory = /** @class */ (function () {
    function IUILanguageFactory() {
    }
    IUILanguageFactory.getRU = function () {
        return {
            category: {
                main: "Главная",
                gateway: "Шлюзы",
                bonuses: "Бонусы",
                content: "Контент",
                finance: "Финансы",
                employees: "Сотрудники",
                options: "Настройки",
                partners: "Партнеры",
                reports: "Отчеты",
                support: "Техподдержка",
                security: "Безопасность",
                paysystem: "Платежи",
                exit: "Выход",
            },
            layout: {
                menu: {
                    account: {
                        title: "Аккаунт",
                        profile: "Профиль",
                        exit: "Выход"
                    }
                }
            },
            version: {
                text_fmt: "Управление казино. Версия {0} от {1}"
            },
            pages: {
                auth: {
                    error: {
                        title: "ОШИБКА",
                        msg_login_empty: "ЛОГИН ПУСТОЙ",
                        msg_pass_empty: "ПАРОЛЬ ПУСТОЙ",
                        msg_email_empty: "EMAIL ПУСТОЙ",
                    }
                },
                page_404: {
                    text_404: "СТРАНИЦА НЕ НАЙДЕНА"
                }
            }
        };
    };
    IUILanguageFactory.getEN = function () {
        return {
            category: {
                main: "Main",
                gateway: "Gateways",
                bonuses: "Bonuses",
                content: "Content",
                finance: "Finance",
                employees: "Employees",
                options: "Options",
                partners: "Partners",
                reports: "Reports",
                support: "Support",
                security: "Security",
                paysystem: "Paysystem",
                exit: "Exit",
            },
            layout: {
                menu: {
                    account: {
                        title: "Account",
                        profile: "Profile",
                        exit: "Exit"
                    }
                }
            },
            version: {
                text_fmt: "Casino admin panel. Version {0} build date {1}"
            },
            pages: {
                auth: {
                    error: {
                        title: "ERROR",
                        msg_login_empty: "LOGIN IS EMPTY",
                        msg_pass_empty: "PASSWORD IS EMPTY",
                        msg_email_empty: "EMAIL IS EMPTY",
                    }
                },
                page_404: {
                    text_404: "PAGE NOT FOUND"
                }
            }
        };
    };
    IUILanguageFactory.getLangInstance = function (Lang) {
        if (Lang == "RU") {
            return this.getRU();
        }
        return this.getEN();
    };
    return IUILanguageFactory;
}());
exports.IUILanguageFactory = IUILanguageFactory;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/UILanguage.ts
// module id = 157
// module chunks = 0